import React, { useState } from 'react'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { useViewStore } from '../../Contexts/ViewContext'
import useCloseButtonTop from '../../../hooks/useCloseButtonTop'
import DashboardButton from '../../Menu/Remote/DashboardButton'

interface AbsoluteLargeClosingButtonProps {
  dashboardVisible: boolean
  zIndexClassname?: string
  customComponent?: boolean
  onClick: () => void
}

const AbsoluteLargeClosingButton = ({ dashboardVisible, zIndexClassname, customComponent, onClick }: AbsoluteLargeClosingButtonProps): JSX.Element => {
  const hideMenu = useRetorikStore((state) => state.configuration.hideMenu)
  const isMobile = useViewStore((state) => state.isMobile)
  const useOldRemote = useRetorikStore((state) => state.configuration.useOldRemote)
  const top = useCloseButtonTop()
  const [hidden, setHidden] = useState<boolean>(false)

  const handleHideAndClose = (): void => {
    dashboardVisible && !customComponent && setHidden(true)
    onClick()
  }

  return isMobile ? (
    <React.Fragment />
  ) : useOldRemote ? (
    <div
      className={`rf-absolute ${hidden && 'rf-hidden'} rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname || 'rf-z-ui'}`}
      style={{
        top: hideMenu ? `calc(${top} - 6rem)` : top
      }}
    >
      <DashboardButton dashboardVisible={dashboardVisible} onClick={handleHideAndClose} />
    </div>
  ) : (
    <React.Fragment />
  )
}

export default AbsoluteLargeClosingButton
